export const dateToLocaleString = (date?: Date): string =>
  date?.toLocaleString(undefined, {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  }) || '';
